import _ from 'lodash';
import { INSTANT_QUOTE_STATUS, INSTANT_QUOTE_TYPES } from '@/constants';
import { lsRequiredServiceItemIconStatusConstants } from '@/components/ServiceItems/LsRequiredServiceItem/LsRequiredServiceItemConstants';

const getRequiredServiceItemDisplayValues = ({ requiredService }) => {
  const { icon, status } = _.cloneDeep(
    lsRequiredServiceItemIconStatusConstants[requiredService.status]
  );
  const endDate = _.get(requiredService, status.endDatePath);
  const isLGQ = requiredService.type === INSTANT_QUOTE_TYPES.LONG_GRASS;
  const color = isLGQ ? 'danger' : 'primary';

  return {
    icon,
    statusText: status.text,
    endDate,
    color,
    isLGQ,
  };
};

const getRequiredServiceItemStatusFromLGQ = ({ instant_quote_status }) => {
  switch (instant_quote_status) {
    case INSTANT_QUOTE_STATUS.CUSTOMER_PENDING:
      return 'ready';

    case INSTANT_QUOTE_STATUS.CUSTOMER_ACCEPTED:
      return 'approved';

    case INSTANT_QUOTE_STATUS.CUSTOMER_REJECTED:
      return 'rejected';

    case INSTANT_QUOTE_STATUS.CANCELLED:
      return 'cancelled';

    default:
      return 'new';
  }
};

// eslint-disable-next-line import/prefer-default-export
export const lsRequiredServiceItemHelpers = {
  getRequiredServiceItemDisplayValues,
  getRequiredServiceItemStatusFromLGQ,
};
